module.exports = __webpack_public_path__ + "img/screen_iphone3.5eb9bd16.png";